import React from 'react';
//import axios from 'axios';
import api from './../../../services/api';
import { NavLink } from 'react-router-dom';
import { user_token } from '../../../services/Auth';
import { withRouter } from 'react-router-dom'
import './../Prontuario_Inicial/styles.css'

//import da API
import { professional } from './../../../services/api';
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);
var medico_id = localStorage.getItem("professional_id");

class AgendamentoCPE extends React.Component {

    //PATCH LOGIC
    constructor() {
        super();
        this.state = {
            appointment_date: "",
            appointment_time: "",
            notes: "",
            professional_id: medico_id,

        };
        this.handleChange = this.handleChange.bind(this);
        //this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
        //this.setState({value: evt.target.value});
    }

    handleSubmit = evt => {
        evt.preventDefault();

        const exam = {
            //updatedAt: this.state.updatedAt,
            possible_date: {
                appointment_date: this.state.appointment_date + "T" + this.state.appointment_time,
                notes: this.state.notes,
                professional_id: this.state.professional_id
            }

        };

        //Print dos dados enviados
        console.log(exam);

        //ID está setada -> Necessário Correção
        //api.patch(`/exam/${this.props.exam_id}`, exam, {headers: {'x-access-token': token, 'op': "add"} })
        apiProfessional.editExam(exam, this.props.exam_id, 'add')
            .then(res => {
                console.log(res);
                console.log(res.data);
                window.history.back()
                alert("Confirmação de consulta realizada com sucesso! Aguarde aprovação dos Organizadores!")
            })

    }

    render() {
        return (
            <>
                <br></br>
                <form onSubmit={this.handleSubmit} id="forms-RI-Cadastro">
                    <h1 id="tittle-forms-cme">Formulário Agendamento de Consulta</h1>

                    <p id="RI-Title-Cadastro" >Insira uma data possível para realização do atendimento</p>
                    <input onChange={this.handleChange} name="appointment_date" type="date" id="RI-Cadastro" required />
                    <input onChange={this.handleChange} name="appointment_time" type="time" id="RI-Cadastro" required />
                    <p id="RI-Title-Cadastro" >Notas</p>
                    <textarea onChange={this.handleChange} name="notes" placeholder="Acrescentar Notas de observação: " id="RI-Cadastro" />

                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <button onClick={() => this.handleSubmit} id="confirmar-button">Confirmar</button>
                        <NavLink to="Tela_ps_painel"><button id="recusar-button">Recusar</button></NavLink>
                    </div>
                </form>
            </>
        );
    }
}
export default withRouter(AgendamentoCPE)
/*
possible_date: [
                {
                    appointment_date: "",
                    notes: "",
                    professional_id: medico_id,
                }
            ]
 */
